import { JsonApiResource } from 'json-api';

export type Status =
  | 'draft'
  | 'validation'
  | 'live'
  | 'draftUpdate'
  | 'validationUpdate'
  | 'validationPaused'
  | 'paused'
  | 'validationDisabled'
  | 'disabled';

export class AtomResource extends JsonApiResource {
  canUpdateStatus(status: Status): boolean {
    return (
      this.meta.validation &&
      this.meta.validation.allowed_status.includes(status)
    );
  }

  isAssociatedAt(resource?: AtomResource): boolean {
    const associatedAt = this.meta?.associated_at;

    if (!resource || !associatedAt) {
      return false;
    }
    return (
      associatedAt.id === resource.id && associatedAt.type === resource.type
    );
  }
}
